import React from "react";
import { Link } from "~/components/Elements";

type Props = {
  active: "osk" | "oso";
};

const Volby2026Nav = ({ active }: Props) => {
  return (
    <div className="v26-nav">
      <Link
        to="/volby-2026/volby-do-organov-samospravnych-krajov"
        className={"v26-nav-item" + (active === "osk" ? " active" : "")}
      >
        Voľby do orgánov samosprávnych krajov
      </Link>
      <Link
        to="/volby-2026/volby-do-organov-samospravy-obci"
        className={"v26-nav-item" + (active === "oso" ? " active" : "")}
      >
        Voľby do orgánov samosprávy obcí
      </Link>
    </div>
  );
};

export default Volby2026Nav;
